import { addTimeZoneOffset } from './removeTimeZoneOffset';

function pad(i: any): any {
  return i < 10 ? `0${i}` : `${i}`;
}

export function getIcalDateString(date: Date) {
  date = addTimeZoneOffset(date);

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hour = pad(date.getUTCHours());
  const minute = pad(date.getUTCMinutes());
  const second = pad(date.getUTCSeconds());
  return `${year}${month}${day}T${hour}${minute}${second}Z`;
}
